import { FormActions } from "../../components/common/FormActions";
import {
  //   createApproveAction,
  createViewAction,
  formatDate,
  formatDateTime,
  numberFormat,
} from "../../utils/helpers";
import { URL_WEEKLY_WAGES_COLLECTIONS } from "../../utils/urls";
import {
  BooleanTags,
  PaymentStatusTag,
} from "../../components/common/registerUtils";
import dayjs from "dayjs";
import { APPROVE } from "../../utils/constants";
import { Modal } from "antd";
import useSet from "../common/useSet";
import { API_WEEKLY_COLLECTIONS } from "../../utils/apis";
import toast from "react-hot-toast";
import { useToasts } from "../common/useToasts";

const useWeeklyCollections = () => {
  const { uploadData, success, error } = useSet();
  const handleApprove = (id: any) => {
    Modal.confirm({
      title: "Confirm Approval",
      content: (
        <div>
          <p>Are you sure you want to approve this wage?</p>
        </div>
      ),
      okText: "Yes, Approve",
      cancelText: "Cancel",
      onOk: async () => {
        try {
          await uploadData({
            api: `${API_WEEKLY_COLLECTIONS}${id}/approve/`,
            method: "POST",
          });
        } catch (error) {
          toast.error("Failed to approve request");
        }
      },
    });
  };

  useToasts({
    success,
    error,
    redirect: "reload",
    successMessage: "Operation Successfull",
  });

  const tableColumns = () => [
    {
      id: "staff_name",
      header: "Staff Name",
      filter: {
        type: "text",
      },
    },
    {
      id: "staff_code",
      header: "Staff Code",
      filter: {
        type: "text",
      },
    },
    {
      id: "staff_type",
      header: "Staff Type",
      filter: {
        type: "text",
      },
    },
    {
      id: "total_collections",
      header: "Total Collections",
    },
    {
      id: "commission_percentage",
      header: "Commission Percentage",
    },
    {
      id: "commission_amount",
      header: "Commission Amount",
    },
    {
      id: "fixed_wage_amount",
      header: "Fixed Wage Amount",
    },
    {
      id: "total_wage",
      header: "Total Wage",
    },
    {
      id: "period_start",
      header: "Period Start",
      filter: {
        type: "date",
      },
    },
    {
      id: "period_end",
      header: "Period End",
      filter: {
        type: "date",
      },
    },
    {
      id: "is_approved",
      header: "Is Approved",
    },
    {
      id: "payment_status",
      header: "Payment Status",
    },
    {
      id: "created_at",
      header: "Created At",
      filter: {
        type: "date",
      },
    },
    {
      id: "created_by",
      header: "Created By",
      filter: {
        type: "text",
      },
    },
    {
      id: "actions",
      header: "Actions",
    },
  ];

  const tableData = (data: any) => [
    ...data?.map((item: any) => {
      return {
        ...item,
        fixed_wage_amount: numberFormat(item?.fixed_wage_amount),
        commission_amount: numberFormat(item?.commission_amount),
        is_approved: <BooleanTags status={item?.is_approved} />,
        payment_status: <PaymentStatusTag status={item?.payment_status} />,
        created_at: formatDateTime(item?.created_at),
        created_by: `${item?.created_by?.first_name} ${item?.created_by?.last_name}`,

        actions: (
          <FormActions
            actions={[
              createViewAction(URL_WEEKLY_WAGES_COLLECTIONS, item?.id),
              ...(!item.is_approved
                ? [
                    {
                      label: APPROVE,
                      custom: true,
                      handleCustom: () => handleApprove(item?.id),
                    },
                  ]
                : []),
            ]}
          />
        ),
      };
    }),
  ];

  const viewData = (item: any) => {
    return {
      sections: [
        {
          title: "Staff & Wage Details",
          fields: {
            "Staff Name": item?.staff_details?.user_full_name,
            "Staff Code": item?.staff_details?.staff_code,
            "Staff Type": item?.staff_details?.staff_type,
            "Phone Number": item?.staff_details?.phone_number,
            Email: item?.staff_details?.user_email,

            "Period Start": formatDate(item?.period_start),
            "Period End": formatDate(item?.period_end),

            "Total Collections": numberFormat(item?.total_collections),
            "Commission %": item?.commission_percentage,
            "Commission Amount": numberFormat(item?.commission_amount),
            "Fixed Wage": numberFormat(item?.fixed_wage_amount),
            "Total Wage": numberFormat(item?.total_wage),

            Approved: <BooleanTags status={item?.is_approved} />,
            "Approved By": item?.approved_by_name,
            "Approved At": formatDateTime(item?.approved_at),
          },
        },
      ],
    };
  };

  const initialFilters = {
    start_date: dayjs().format("YYYY-MM-DD"),
    end_date: dayjs().format("YYYY-MM-DD"),
  };

  const externalFilters = [
    {
      id: "collection_date",
      label: "Collection Date Range",
      type: "date",
      options: [],
    },
  ];

  const tableTitle = "Weekly Collections";
  const activityFilter = "wage_calculation";

  return {
    tableColumns,
    tableData,
    initialFilters,
    externalFilters,
    tableTitle,
    viewData,
    activityFilter,
  };
};

export default useWeeklyCollections;

// export const useWeeklyCollectionsActionsForm = ({ form, data }: any) => {
//   const { uploadData, success, error, submitting } = useSet();

//   useToasts({
//     success,
//     error,
//     submitting,
//     redirect: "reload",
//     successMessage: "Wage payments confirmed successfully",
//   });
//   const showActionForm = true;

//   const fields = [
//     ...(showActionForm
//       ? [
//           {
//             field_name: "action",
//             label: "Action",
//             type: "select",
//             options_data: [{ name: "Confirm", id: CONFIRMED }],
//             props: { required: true },
//           },
//           {
//             field_name: "confirmation_notes",
//             label: "Confirmation Notes",
//             type: "textarea",
//             props: { required: true },
//           },
//         ]
//       : []),
//   ];

//   function onSubmit(payload: any) {
//     if (!data) return null;
//     return uploadData({
//       api: `${API_WAGE_PAYMENTS_HISTORY}${data?.id}/confirm/`,
//       params: { id: data?.id, confirmation_notes: payload?.confirmation_notes },
//     });
//   }

//   const enableSubmit = !!form?.action && !!form?.confirmation_notes;

//   return {
//     fields,
//     onSubmit,
//     enableSubmit,
//     showActionForm,
//     finalStates: [CONFIRMED, REJECTED],
//   };
// };
